module.exports = "/_next/static/images/HeroIndustryStartups@2x-aefd9d7aef00a8cbba24c278ace4add0.webp";